import { css, type Theme } from "@emotion/react";

export const row = (theme: Theme) => css`
  display: flex;
  align-items: flex-start;
  gap: ${theme.ds5.spacing.gap.medium};
`;

export const iconContainer = (theme: Theme) => css`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: ${theme.ds5.radius.background.rounded};
  background-color: ${theme.ds5.neutral.backgroundLevel0};
`;

export const textStack = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.ds5.spacing.gap.xsmall};
`;
